import logger from "../../../utils/logger";
import {
  addLocationResource,
  editLocationResource,
  loadLocationResources,
  loadLocationResourcesSuccess,
  loadResourceItem,
  loadResourceItemSuccess,
  setLocation
} from "../reducer/locationResources";
import * as uiActions from "../reducer/ui";

const loadLocationResourcesFlow = ({
  getAllLocationResourceList,
  getLocationResourceList,
}) => ({ dispatch, getState }) => (next) => async (action) => {
  next(action);
  if (action.type === loadLocationResources.type) {
    dispatch(uiActions.setLoading(true));
    try {
      dispatch(setLocation(action.payload.name.split("_").join(' ')));
      let response;
      if (action.payload.name === "All_Locations") {
        response = await getAllLocationResourceList();
      } else {
        response = await getLocationResourceList(action.payload.name);
      }
      if (action.payload.mounted)
        dispatch(loadLocationResourcesSuccess(response.data));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const loadLocationResourceItemFlow = ({ getLocationResourceItem }) => ({
  dispatch,
  getState,
}) => (next) => async (action) => {
  next(action);
  if (action.type === loadResourceItem.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await getLocationResourceItem(action.payload);
      dispatch(loadResourceItemSuccess(response.data));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const addLocationResourceFlow = ({ postLocationResource }) => ({
  dispatch,
  getState,
}) => (next) => async (action) => {
  next(action);
  if (action.type === addLocationResource.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await postLocationResource(action.payload);
      logger()(response.data);
      dispatch(
        uiActions.setToast(response.data.msg)//`Changes ${action.payload.result}ed successfully`)
      );
      dispatch(
        loadLocationResources({
          name: getState().locationResources.location.split(" ").join('_'),
          mounted: true,
        })
      );
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const editLocationResourceFlow = ({ postEditLocationResource }) => ({
  dispatch,
  getState,
}) => (next) => async (action) => {
  next(action);
  if (action.type === editLocationResource.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await postEditLocationResource(
        getState().locationResources.itemResourceRequest.linkedTo,
        action.payload
      );
      logger()(response.data);
      dispatch(
        uiActions.setToast(response.data.msg)//`Changes ${action.payload.result}ed successfully`)
      );
      dispatch(
        loadLocationResources({
          name: getState().locationResources.location.split(" ").join('_'),
          mounted: true,
        })
      );
    } catch (error) {
      logger()(error.message);
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const locationResourcesFlow = [
  loadLocationResourcesFlow,
  loadLocationResourceItemFlow,
  addLocationResourceFlow,
  editLocationResourceFlow,
];

export default locationResourcesFlow;
